import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  return <section className="py-10 border-y border-dark-border bg-dark-card/50" data-id="element-238">
      <div className="max-w-4xl mx-auto px-4" data-id="element-239">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center justify-center text-center" data-id="element-240">
          <span className="text-2xl md:text-3xl mb-4" data-id="element-241">⭐⭐⭐⭐⭐</span>
          <span className="text-lg md:text-xl text-text-secondary font-medium max-w-2xl" data-id="element-242">
            Más de 300 páginas de contenido exclusivo para quienes disfrutan
            descubrir la historia de una forma apasionante.
          </span>
        </motion.div>
      </div>
    </section>;
}